module.exports = __webpack_public_path__ + "img/win_icon.795c8727.svg";